/**
 * convertRawValue.
 *
 * API出力値のプリミティブ型の値を、指定したEnum型に変換する関数
 * Enumの定義外の値が入力された場合は例外をスローする
 * また、Enumの値はすべて同一のプリミティブ型であることを仮定する
 *
 * @param {T} raw - APIからの出力値など、string, number等のプリミティブ型の値
 * @param {Object} typeObject - enumを定義するオブジェクト
 * @returns {U} - 変換後のenumの型の値
 * @throws {TypeError} - 未定義のプリミティブ型の値が入力された場合にTypeErrorをthrowする
 */
export function convertRawValue<T, U>(raw: T, typeObject: Object): U {
  const pairArray = Object.entries(typeObject)
  const res = pairArray.find(e => e[1] === raw)
  if (!res) {
    throw new TypeError(`unknown enum value: raw: ${raw}, typeObject keys: ${Object.keys(typeObject)}`)
  }
  return res[1] as U
}
